<idp-switching-account
  *ngIf="facade.switchingAccountService.displayBody | ngrxPush"
  [content]="
    (facade.switchingAccountDetails$ | ngrxPush) ||
    emptySwitchingAccountContentDetails
  "
></idp-switching-account>
